import React, { useState, useEffect } from "react";
import axios, { renderDoc } from "../Axiosinstance";
import {
  Modal,
  // Button,
  Form,
  Row,
  Col,
  FormGroup,
  FormLabel,
  FormControl,
  FormCheck,
} from "react-bootstrap";
import Button from '@mui/material/Button';
import { Link, useParams } from "react-router-dom";
import Header from "../components/Header";
import { useNavigate } from "react-router-dom";
import { FaMinus, FaPlus } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseURLdyte, buttonBackgroundColor, Password, Username } from "../common";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';


const EditBatchForm = ({ onFormSubmit }) => {
  const [selectedTrainers, setSelectedTrainers] = useState([]);
  const [selectedAssessors, setSelectedAssessors] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [facilitatorData, setFacilitatorData] = useState(null);
  const { BatchId } = useParams();
  const [searchText, setSearchText] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  // const [categories, setCategories] = useState([]);
  const [courseImage, setCourseImage] = useState("");
  const [errorMessage, setErrorMessage] = useState('');
  const [errorMessageName, setErrorMessageName] = useState('');

  const navigate = useNavigate();

  const [batchData, setBatchData] = useState({
    course: "",
    batchcode: "",
    onlineclasslink: "",

    venue: "",

    courseId: "",
    courseImage: "",
    name: "",
    type: "",
    currentModule: "",
    courseFee: "",
    registrationFee: "",
    courseType: "",
    moduleDetails: [
      {
        moduleName: "",
      },
    ],

    moduleNames: [
      { id: 1, moduleName: " " },
      { id: 2, moduleName: " " },
      { id: 3, moduleName: " " },
      { id: 4, moduleName: " " },
      { id: 5, moduleName: " " },
      { id: 6, moduleName: " " },
    ],
    reference: "",
    description: "",
    outcome: "",
    requirement: "",
    // category: { id: '' },

    days: [
      {
        id: "",
        day: "",
        sessionIndex: 0,
        sessions: {},
        startTime: "",
        endTime: "",
      },
    ],
    lessonsPerWeek: "",
    assignment: false,
  });
  // const [days, setDays] = useState([]);
  // Add these state variables
  const [allSelectedTrainers, setAllSelectedTrainers] = useState([]);
  const [allSelectedAssessors, setAllSelectedAssessors] = useState([]);
  //changes done here for intakeId
  const [batchData1, setBatchData1] = useState({
    intakeIdReset: "",
    message: "", // To store success or error messages
    error: false, // To indicate if there's an error
  });
  const fetchAllIntakeCounters = async () => {
    try {
      const response = await axios.get(
        `registrationadvances/getintakecounter/${BatchId}`
      );
      const currentGlobalIntakeCounter =
        response.data.globalIntakeCounter.toString(); // Assuming response contains globalIntakeCounter

      setBatchData1({
        ...batchData1,
        intakeIdReset: currentGlobalIntakeCounter,
        message: "",
        error: false,
      });

      console.log(response.data); // Logging the entire response data
    } catch (error) {
      console.error("Failed to fetch globalIntakeCounter", error);
      // Handle error as needed
      setBatchData1({
        ...batchData1,
        message: "Failed to fetch current Intake ID",
        error: true,
      });
    }
  };

  // Fetch initial globalIntakeCounter on component mount
  useEffect(() => {
    fetchAllIntakeCounters();
  }, []); // Empty dependency array ensures this effect runs only once on mount

  const handleInputChange1 = (event) => {
    const { name, value } = event.target;
    setBatchData1({ ...batchData1, [name]: value });
  };

  const CLOUDINARY_URL = "https://api.cloudinary.com/v1_1/dyjwwi8ea/raw/upload";
  const CLOUDINARY_UPLOAD_PRESET = "vldqgwk8";

  const handleImageUpload = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) {
        return;
      }

      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
      formData.append("public_id", "LMS/courses/" + file.name);

      const response = await fetch(CLOUDINARY_URL, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.secure_url) {
        setBatchData((prevData) => ({
          ...prevData,
          courseImage: data.secure_url,
        }));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleResetIntakeId = async () => {
    try {
      const newGlobalIntakeCounter1 = parseInt(batchData1.intakeIdReset);

      if (isNaN(newGlobalIntakeCounter1)) {
        throw new Error("Intake ID reset is not a valid number");
      }

      const response = await axios.put(
        `registrationadvances/${BatchId}/global-intake-counter`,
        {
          globalIntakeCounter: newGlobalIntakeCounter1,
        }
      );

      setBatchData1({
        ...batchData1,
        message: "Intake ID reset successfully!",
        error: false,
      });

      // Optional: Show alert here
      alert("Intake ID reset successfully!");
    } catch (error) {
      console.error("Update failed", error);
      setBatchData1({
        ...batchData1,
        message: "Failed to update intake ID",
        error: true,
      });
    }
  };

  const handleModuleSelect = (moduleId) => {
    setBatchData((prevBatchData) => ({
      ...prevBatchData,
      currentModule: moduleId,
    }));
  };

  const sortSessions = (sessions) => {
    const sortedSessionKeys = Object.keys(sessions).sort((a, b) => {
      const numA = parseInt(a.split(" ")[1], 10);
      const numB = parseInt(b.split(" ")[1], 10);
      return numA - numB;
    });

    const sortedSessions = {};
    sortedSessionKeys.forEach((key) => {
      sortedSessions[key] = sessions[key];
    });

    return sortedSessions;
  };

  useEffect(() => {
    const fetchBatchData = async () => {
      try {
        const response = await axios.get(`batch/${BatchId}`);
        // setBatchData(response.data);
        // setDays(response.data.days || []);
        // Sort sessions for each day
        const data = response.data;
        const sortedDays = data.days.map((day) => ({
          ...day,
          sessions: sortSessions(day.sessions),
        }));

        // Update state with sorted data
        setBatchData({
          ...data,
          days: sortedDays,
        });

        // Update selected trainers and assessors based on fetched data
        setSelectedTrainers(response.data.trainers || []);
        setSelectedAssessors(response.data.assessors || []);
      } catch (error) {
        console.error("Error fetching batch data:", error);
      }
    };
    fetchBatchData();
  }, [BatchId]);

  useEffect(() => {
    axios
      .get("courses")
      .then((response) => setCourses(response.data))
      .catch((error) => console.error("Error fetching course data:", error));
  }, []);

  useEffect(() => {
    axios
      .get("venues")
      .then((response) => setVenues(response.data))
      .catch((error) => console.error("Error fetching venue data:", error));
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSelectTrainer = (trainer) => {
    setSelectedTrainers((prevTrainers) => {
      const newTrainers = [...prevTrainers, trainer];
      setAllSelectedTrainers(newTrainers);
      setBatchData((prevData) => ({
        ...prevData,
        trainers: newTrainers,
      }));
      return newTrainers;
    });
  };

  const handleSelectAssessor = (assessor) => {
    setSelectedAssessors((prevAssessors) => {
      const newAssessors = [...prevAssessors, assessor];
      setAllSelectedAssessors(newAssessors);
      setBatchData((prevData) => ({
        ...prevData,
        assessors: newAssessors,
      }));
      return newAssessors;
    });
  };

  const handleDeleteTrainer = (trainerToRemove) => {
    setSelectedTrainers((prevTrainers) =>
      prevTrainers.filter((trainer) => trainer !== trainerToRemove)
    );
    // Update batchData to remove the trainer
    setBatchData((prevData) => ({
      ...prevData,
      trainers: prevData.trainers.filter(
        (trainer) => trainer !== trainerToRemove
      ),
    }));

    // Mark the form as modified when deleting a trainer
    setFormModified(true);
  };

  const handleDeleteAssessor = (assessorToRemove) => {
    setSelectedAssessors((prevAssessors) =>
      prevAssessors.filter((assessor) => assessor !== assessorToRemove)
    );

    // Update batchData to remove the assessor
    setBatchData((prevData) => ({
      ...prevData,
      assessors: prevData.assessors.filter(
        (assessor) => assessor !== assessorToRemove
      ),
    }));

    // Mark the form as modified when deleting an assessor
    setFormModified(true);
  };

  const fetchFacilitatorDetails = () => {
    axios
      .get("facilitators")
      .then((response) => setFacilitatorData(response.data))
      .catch((error) =>
        console.error("Error fetching facilitator data:", error)
      );
  };

  useEffect(() => {
    fetchFacilitatorDetails();
  }, []);

  const handleAddAssessor = () => {
    fetchFacilitatorDetails();
    setShowModal(true);
  };

  const [formModified, setFormModified] = useState(false);

  useEffect(() => {
    const handleFormModification = () => {
      if (!formModified) {
        setFormModified(true);
      }
    };

    window.addEventListener("input", handleFormModification);
    return () => {
      window.removeEventListener("input", handleFormModification);
    };
  }, [formModified]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (formModified) {
        event.returnValue =
          "You have unsaved changes. Are you sure you want to leave this page?";
      }
    };
    window.onbeforeunload = handleBeforeUnload;
    return () => {
      window.onbeforeunload = null;
    };
  }, [formModified]);

  const [courses, setCourses] = useState([]);
  const [venues, setVenues] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {

        const venuesResponse = await axios.get('venues');
        setVenues([{ id: 'Online/Classroom', roomno: 'Online/Classroom' }, ...venuesResponse.data]);

        //   const categoriesResponse = await axios.get('categorys');
        //   setCategories(categoriesResponse.data);

        fetchFacilitatorDetails();
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const hasDuplicates = (arr) => {
    const names = arr.map((m) => m.moduleName.trim().toLowerCase());
    return new Set(names).size !== names.length;
  };

  const handleInputChange = (e, id) => {
    const { name, value, type, checked } = e.target;

    // Handle moduleDetails (moduleX_name)
    if (name.startsWith("module") && name.includes("_name")) {
      const moduleIndex = parseInt(name.substring(6)) - 1;

      // Update state first
      setBatchData((prevData) => {
        const updatedModules = prevData.moduleDetails.map((module, idx) =>
          idx === moduleIndex ? { ...module, moduleName: value } : module
        );

        // Validate for duplicates
        if (hasDuplicates(updatedModules)) {
          setErrorMessage("Module name must be unique.");
        } else {
          setErrorMessage("");
        }

        return {
          ...prevData,
          moduleDetails: updatedModules,
        };
      });
    }

    // Handle moduleNames (moduleNameX)
    else if (name.startsWith("moduleName")) {
      const moduleIndex = parseInt(name.substring(10)) - 1;

      setBatchData((prevData) => {
        const updatedNames = prevData.moduleNames.map((module, idx) =>
          idx === moduleIndex ? { ...module, moduleName: value } : module
        );

        if (hasDuplicates(updatedNames)) {
          setErrorMessageName("Module name must be unique.");
        } else {
          setErrorMessageName("");
        }

        return {
          ...prevData,
          moduleNames: updatedNames,
        };
      });
    }

    // Sync batchcode and course
    else if (name === "batchcode") {
      setBatchData((prevData) => ({
        ...prevData,
        batchcode: value,
        course: value,
      }));
    } else if (name === "course") {
      setBatchData((prevData) => ({
        ...prevData,
        course: value,
        batchcode: value,
      }));
    }

    // Checkboxes
    else if (type === "checkbox") {
      setBatchData((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
    }

    // Other fields
    else {
      setBatchData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };


  const handleInputChange11 = (dayIndex, fieldName, event) => {
    const { value } = event.target;
    const newDays = [...batchData.days];
    newDays[dayIndex] = { ...newDays[dayIndex], [fieldName]: value };
    setBatchData({ ...batchData, days: newDays });
  };

  const getDisabledDays = (dayIndex) => {
    const selectedDays = batchData.days
      .slice(0, dayIndex)
      .map((day) => day.day); // Get days selected in previous rows
    const dayOrder = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];


    const maxSelectedIndex = Math.max(
      ...selectedDays.map((day) => dayOrder.indexOf(day)),
      -1 // Default value if no days are selected
    );

    // Disable days that come before or equal to the max selected index
    return dayOrder.reduce((disabledMap, day, index) => {
      disabledMap[day] = index <= maxSelectedIndex;
      return disabledMap;
    }, {});
  };

  const handleAddRow = () => {
    setBatchData((prevData) => ({
      ...prevData,
      days: [
        ...prevData.days,
        {
          id: "",
          day: "",
          sessionIndex: prevData.days.length,
          sessions: {},
          startTime: "",
          endTime: "",
        },
      ],
    }));
  };

  const handleRemoveRow = (dayIndex) => {
    if (batchData.days.length > 1) {
      const newDays = batchData.days.filter((_, index) => index !== dayIndex);
      setBatchData((prevData) => ({
        ...prevData,
        days: newDays,
      }));
    }
  };

  const handleSessionChange = (dayIndex, sessionIndex, fieldName, event) => {
    const { value } = event.target;
    const newDays = [...batchData.days];
    const sessions = { ...newDays[dayIndex].sessions };
    const sessionKey = `Session ${sessionIndex + 1}`;

    const otherField = fieldName === "startTime" ? "endTime" : "startTime";
    const otherTime = sessions[sessionKey][otherField];

    const newStart = fieldName === "startTime" ? value : otherTime;
    const newEnd = fieldName === "endTime" ? value : otherTime;

    if (!newStart || !newEnd) {
      sessions[sessionKey] = {
        ...sessions[sessionKey],
        [fieldName]: value,
      };
      newDays[dayIndex] = { ...newDays[dayIndex], sessions };
      setBatchData({ ...batchData, days: newDays });
      return;
    }

    if (newStart >= newEnd) {
      alert("Start time must be before end time.");
      return;
    }

    // ✅ Overlap validation
    for (const [key, session] of Object.entries(sessions)) {
      if (key === sessionKey) continue;

      const existingStart = session.startTime;
      const existingEnd = session.endTime;

      if (!existingStart || !existingEnd) continue;

      if (newStart < existingEnd && newEnd > existingStart) {
        alert(`Time conflicts with ${key}. Please select a different time.`);
        return;
      }
    }

    // ✅ Sequence validation: current session should start AFTER previous one ends
    if (sessionIndex > 0) {
      const prevSessionKey = `Session ${sessionIndex}`;
      const prevSession = sessions[prevSessionKey];

      if (prevSession?.startTime && prevSession?.endTime) {
        const prevEnd = prevSession.endTime;

        if (newStart <= prevEnd) {
          alert(`Start time must be after end time of ${prevSessionKey}.`);
          return;
        }
      }
    }

    // ✅ All checks passed, update state
    sessions[sessionKey] = {
      ...sessions[sessionKey],
      [fieldName]: value,
    };

    newDays[dayIndex] = { ...newDays[dayIndex], sessions };
    setBatchData({ ...batchData, days: newDays });
  };

  const handleAddSession = (dayIndex) => {
    const newDays = [...batchData.days];
    const currentSessions = newDays[dayIndex].sessions;
    const newSessionNumber = Object.keys(currentSessions).length + 1; // Adjust if needed

    newDays[dayIndex].sessions = {
      ...currentSessions,
      [`Session ${newSessionNumber}`]: {
        startTime: "",
        endTime: "",
      },
    };

    setBatchData({ ...batchData, days: newDays });
  };

  const handleRemoveSession = (dayIndex, sessionIndex) => {
    const newDays = [...batchData.days];
    const newSessions = { ...newDays[dayIndex].sessions };

    // Remove the selected session
    const sessionKeys = Object.keys(newSessions);
    sessionKeys.splice(sessionIndex, 1); // Remove the session at sessionIndex

    // Create a new object for sessions and reassign the keys
    const updatedSessions = {};
    sessionKeys.forEach((sessionKey, index) => {
      updatedSessions[`Session ${index + 1}`] = newSessions[sessionKey];
    });

    // Update the days with the new sessions
    newDays[dayIndex] = { ...newDays[dayIndex], sessions: updatedSessions };
    setBatchData({ ...batchData, days: newDays });
  };

  const [showUpdateConfirmationModal, setShowUpdateConfirmationModal] =
    useState(false);

  const handleUpdate = async () => {
    setShowUpdateConfirmationModal(true);
  };

  const handleConfirmUpdate = async () => {
    const formattedDays = batchData.days.map((day) => ({
      day: day.day,
      sessions: Object.keys(day.sessions).reduce((acc, key) => {
        acc[key] = day.sessions[key];
        return acc;
      }, {}),
    }));

    try {
      // Check if all required fields are filled
      if (
        !batchData.batchcode ||
        !batchData.course ||
        // !batchData.attendanceqrlink ||
        !batchData.onlineclasslink ||
        !batchData.venue
      ) {
        toast.error("Please fill in all required fields.");
        return;
      }
      // Prepare updated batch data
      const updatedBatchData = {
        ...batchData,
        trainers: selectedTrainers,
        assessors: selectedAssessors,
        // days: days,
        days: formattedDays,
      };
      console.log("Updating batch with id:", BatchId);
      // if (errorMessage) {
      //   console.error('Cannot submit due to validation error:', errorMessage);
      //   return; // Exit the function early if there's an error
      // }
      const response = await axios.put(`batch/${BatchId}`, updatedBatchData);

      console.log("Response:", response.data);
      if (response.status === 200) {
        console.log("Batch data updated successfully!");
        navigate("/Allcourse");
        // onFormSubmit();
      } else {
        console.error("Failed to update batch data.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error updating batch data.");
    } finally {
      setShowUpdateConfirmationModal(false);
    }
  };

  const handleCancelUpdate = () => {
    setShowUpdateConfirmationModal(false);
  };

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [dayIndexToRemove, setDayIndexToRemove] = useState(null);

  const handleRemoveDay = (dayIndex) => {
    setDayIndexToRemove(dayIndex);
    setShowConfirmationModal(true);
  };

  const confirmRemoveDay = () => {
    // setDays((prevDays) => prevDays.filter((day, index) => index !== dayIndexToRemove));
    setFormModified(true);
    setShowConfirmationModal(false);
    toast.success("Day removed successfully!", {
      position: "bottom-right",
    });
  };

  const cancelRemoveDay = () => {
    setShowConfirmationModal(false);
  };

  const username = Username;
  const password = Password;
  const baseURL = baseURLdyte;
  const [showMeetingModal, setShowMeetingModal] = useState(false);
  const [meetingTitle, setMeetingTitle] = useState("");

  const handleShowMeetingModal = () => {
    setShowMeetingModal(true);
  };

  const handleCloseMeetingModal = () => {
    setShowMeetingModal(false);
  };

  const handleMeetingTitleChange = (e) => {
    setMeetingTitle(e.target.value);
  };

  const handleCreateMeeting = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/meetings`,
        {
          title: meetingTitle,
          preferred_region: "ap-south-1",
          record_on_start: false,
          live_stream_on_start: false,
          recording_config: {
            max_seconds: 60,
            file_name_prefix: "string",
            video_config: {
              codec: "H264",
              width: 1280,
              height: 720,
              watermark: {
                url: "http://example.com",
                size: { width: 1, height: 1 },
                position: "left top",
              },
            },
            audio_config: { codec: "AAC", channel: "stereo" },
            storage_config: {
              type: "aws",
              access_key: "string",
              secret: "string",
              bucket: "string",
              region: "us-east-1",
              path: "string",
              auth_method: "KEY",
              username: "string",
              password: "string",
              host: "string",
              port: 0,
              private_key: "string",
            },
            dyte_bucket_config: { enabled: true },

          },
        },
        {
          auth: {
            username: username,
            password: password,
          },
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response && response.data) {
        // Extract the meeting ID from the response
        const meetingId = response.data.data.id;

        // Omit participant addition in this part of the code

        // Construct the complete meeting link using base link, id, and authToken
        const completeMeetingLink = `${baseURL}/meeting?id=${meetingId}`;

        // Update batchData with the meeting link
        setBatchData((prevData) => ({
          ...prevData,
          onlineclasslink: completeMeetingLink,
        }));

        // Close the meeting modal
        handleCloseMeetingModal();
      } else {
        console.error("Invalid response from Dyte API");
      }
    } catch (error) {
      console.error("Error creating meeting:", error);
    }
  };

  const containerStyle = {
    backgroundColor: "white",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    padding: "20px",
    maxWidth: "800px", // Adjust the max-width as needed
    margin: "auto", // Center the container
    marginTop: "20px", // Add top margin for spacing
  };

  const handleEditorChange = (field) => (value) => {
    setBatchData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  return (
    <div className="batch-form-container">
      <form onSubmit={handleUpdate} className="container" style={containerStyle}>
        <h2 className="mb-4">Edit Course (Jurong Academy)</h2>

        <div className="row">
          <div className="col-md-6">
            {/* Course Name */}
            <div className="form-group mb-3">
              <label htmlFor="CourseName" className="text-start d-block">Course Name:</label>
              <input
                type="text"
                id="batchCode"
                className="form-control"
                name="batchcode"
                value={batchData.batchcode}
                onChange={handleInputChange}
                placeholder="Course Name"
                required
              />
            </div>
          </div>

          <div className="col-md-6">
            {/* Registration Fee */}
            <div className="form-group mb-3">
              <label htmlFor="registrationFee" className="text-start d-block">Registration Fee:</label>
              <input
                type="text"
                id="registrationFee"
                className="form-control"
                name="registrationFee"
                value={batchData.registrationFee}
                onChange={handleInputChange}
                placeholder="Registration Fee"
                required
              />
            </div>
          </div>
        </div>

        {/* NEXT ROW */}
        <div className="row">
          <div className="col-md-6">
            {/* Course Fee */}
            <div className="form-group mb-3">
              <label htmlFor="courseFee" className="text-start d-block">Course Fee:</label>
              <input
                type="text"
                id="courseFee"
                className="form-control"
                name="courseFee"
                value={batchData.courseFee}
                onChange={handleInputChange}
                placeholder="Course Fee"
                required
              />
            </div>
          </div>

          <div className="col-md-6">
            {/* Course Type */}
            <div className="form-group mb-3">
              <label htmlFor="type" className="text-start d-block">Course Type:</label>
              <select
                id="type"
                className="form-control"
                name="type"
                value={batchData.type}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Type</option>
                <option value="diploma">Diploma</option>
                <option value="advance_diploma">Advanced Diploma</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row">
          {/* Column 1 */}
          <div className="col-md-6">
            <div className="form-group mb-3">
              <label htmlFor="courseType" className="text-start d-block">Type:</label>
              <select
                id="courseType"
                className="form-control"
                name="courseType"
                // style={{
                //   // width: "100%",
                //   height: "46px",
                //   borderRadius: "6px",
                //   // border: "1px solid #ced4da",
                // }}
                value={batchData.courseType}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Course Type</option>
                <option value="Part time">Part Time</option>
                <option value="Full time">Full Time</option>
              </select>
            </div>
          </div>

          {/* Column 2 */}
          <div className="col-md-6">
            <div className="form-group mb-3">
              <label className="text-start d-block">Online Class Link:</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  name="onlineclasslink"
                  value={batchData.onlineclasslink}
                  onChange={handleInputChange}
                  placeholder="Enter online class link"
                  style={{
                    height: "42px",
                    borderRadius: "8px 0 0 6px",
                    border: "1px solid #ced4da",
                  }}
                  required
                />
                <Button
                  type="button"
                  variant="outline-secondary"
                  onClick={handleShowMeetingModal}
                  style={{
                    background: buttonBackgroundColor,
                    color: "white",
                    border: "none",
                    borderRadius: "0 8px 8px 0",
                    padding: "5px 10px",
                    cursor: "pointer",
                  }}
                >
                  +
                </Button>
              </div>
            </div>
          </div>
        </div>

        <Modal show={showMeetingModal} onHide={handleCloseMeetingModal}>
          <Modal.Header closeButton>
            <Modal.Title>Enter Meeting Title</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Control
              type="text"
              placeholder="Enter meeting title"
              value={meetingTitle}
              onChange={handleMeetingTitleChange}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="contained" color="error" onClick={handleCloseMeetingModal}>
              Close
            </Button>
            <Button variant="contained" style={{ background: buttonBackgroundColor, marginLeft: '2px' }} onClick={handleCreateMeeting}>
              Create
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="row">
          {/* Column 1 */}
          <div className="col-md-6">
            <div className="form-group mb-3">
              <label className="text-start d-block">Venue:</label>
              <select
                name="venue"
                className="form-control"
                value={batchData.venue || ""} // Ensure it defaults to empty string if venue is undefined
                style={{
                  width: "100%",
                  height: "45px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                }}
                onChange={handleInputChange}
              >
                <option value="" disabled>
                  Select a venue
                </option>
                {venues.map((venue) => (
                  <option key={venue.id} value={venue.roomno}>
                    {venue.roomno}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {/* // change done here for intakeId reset button */}
          <div className="col-md-6">
            <div className="form-group mb-3">
              <label className="text-start d-block">Reset Intake ID</label>
              <div style={{ display: "flex" }}>
                <input
                  type="number"
                  className="form-control"
                  name="intakeIdReset"
                  value={batchData1.intakeIdReset}
                  style={{
                    width: "calc(100% - 42px)",
                    height: "42px",
                    borderRadius: "6px",
                    border: "1px solid #ced4da",
                    marginRight: "5px",
                  }}
                  onChange={handleInputChange1}
                  placeholder={batchData1.intakeIdReset}
                />
                <Button
                  type="button"
                  variant="contained"
                  onClick={handleResetIntakeId}
                  style={{ borderRadius: "6px", background: buttonBackgroundColor }}
                >
                  Reset
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group mb-3">
              <label htmlFor="lessonsPerWeek" className="text-start d-block">Lessons Per Week:</label>
              <input
                type="text"
                id="lessonsPerWeek"
                className="form-control"
                name="lessonsPerWeek"
                value={batchData.lessonsPerWeek || ""}
                onChange={handleInputChange}
                placeholder="Enter number of lessons per week"
                style={{
                  height: "42px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                }}
                required
              />
            </div>
          </div>
          {/* </div> */}

          {/* Course Image Upload */}
          {/* <div className="row"> */}
          <div className="col-md-6">
            <div className="form-group mb-3">
              <label htmlFor="courseImage" className="text-start d-block">Course Image:</label>
              <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                <input
                  type="file"
                  id="courseImage"
                  className="form-control"
                  name="courseImage"
                  onChange={handleImageUpload}
                  style={{
                    height: "42px",
                    borderRadius: "6px",
                    border: "1px solid #ced4da",
                    maxWidth: "250px"
                  }}
                  required
                />
                {/* {batchData.courseImage && (
                  <img
                    src={batchData.courseImage}
                    alt="Course"
                    style={{
                      width: "100px",
                      height: "auto",
                      borderRadius: "6px",
                      border: "1px solid #ddd"
                    }}
                  />
                )} */}

                <Button variant="contained"
                  color="primary" style={{ backgroundColor: buttonBackgroundColor }} onClick={() => renderDoc(batchData.courseImage)}>
                  View
                </Button>
              </div>
            </div>
          </div>

        </div>


        {/* <div> */}
        <h3 style={{ width: '100%', textAlign: 'center', fontWeight: 'bold', fontSize: '1.6rem' }}>Module Details</h3>
        {errorMessage && (
          <div style={{ color: 'red', marginTop: '10px', fontSize: '14px' }}>
            {errorMessage}
          </div>
        )}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)", // Two modules per row
            gap: "20px", // Space between the module cards
            width: "100%",
            padding: "10px",
          }}
        >
          {batchData.moduleDetails.map((module, index) => (
            <div key={index}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <input
                  type="radio"
                  id={`moduleSelect${index}`}
                  name="selectedModule"
                  value={index + 1}
                  checked={batchData.currentModule === index + 1}
                  onChange={() => handleModuleSelect(index + 1)}
                  style={{ marginRight: "10px" }}
                />
                <label htmlFor={`moduleSelect${index}`}>{`Module ${index + 1
                  }`}</label>
              </div>

              {/* Module name input field */}
              <input
                type="text"
                className="form-control "
                name={`module${index + 1}_name`}
                // style={{
                //   width: "100%",
                //   height: "42px",
                //   borderRadius: "6px",
                //   border: "1px solid #ced4da",
                // }}
                value={module.moduleName}
                onChange={(e) => handleInputChange(e, index, "moduleName")}
                placeholder={`Module ${index + 1} Name`}
              />
            </div>
          ))}
        </div>


        <h3 style={{ width: '100%', textAlign: 'center', fontWeight: 'bold', fontSize: '1.6rem' }}>
          Module Names for Mark Sheet
        </h3>
        {errorMessageName && (
          <div style={{ color: 'red', marginTop: '10px', fontSize: '14px' }}>
            {errorMessageName}
          </div>
        )}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)", // Two modules per row
            gap: "20px", // Space between the module cards
            width: "100%",
            padding: "10px",
          }}
        >
          {batchData.moduleNames.map((module, index) => (
            <div key={module.id}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                {/* No radio button */}
                <label>{`Module ${index + 1}`}</label>
              </div>

              {/* Module name input field */}
              <input
                type="text"
                className="form-control"
                name={`moduleName${index + 1}`}
                value={module.moduleName}  // Display default if empty
                onChange={(e) => handleInputChange(e, module.id)}
                placeholder={`Module ${index + 1} Name`}
              />
            </div>
          ))}
        </div>

        {/* </div> */}



        {/* </div> */}
        {/* </div> */}
        {/* </div> */}
        <div style={{ width: "100%", marginTop: "20px" }}>
          <div className="mb-4">
            <div className="mb-3">
              {/* Flex container for heading and button */}
              <div className="d-flex justify-content-between align-items-center mb-2" style={{ position: 'relative' }}>
                <div style={{ width: '100%', textAlign: 'center', fontWeight: 'bold', fontSize: '1.6rem' }}>
                  Selected Trainers
                </div>
                <Button
                  type="button"
                  variant="contained"
                  onClick={() => setShowModal(true)}
                  style={{
                    background: buttonBackgroundColor,
                    color: 'white',
                    fontSize: '12px',
                    position: 'absolute',
                    right: 0,
                  }}
                >
                  <FaPlus style={{ marginRight: 4 }} /> Add Trainer
                </Button>
              </div>

              {batchData.trainers?.length > 0 && (
                <ul className="list-unstyled"  >
                  {batchData.trainers.map((trainer, index) => {
                    const trainerName1 = trainer.replace(/\(.*\)/, "").trim();
                    return (
                      <li key={index} className="d-flex justify-content-between align-items-center border p-2 mb-2 rounded" >
                        <div>{index + 1}. {trainerName1}</div>
                        {/* <Button variant="contained" color="error" onClick={() => handleDeleteTrainer(trainer)}> */}
                        <DeleteRoundedIcon
                          className="text-danger"
                          style={{ color: 'red', marginLeft: 10 }}
                          onClick={() => handleDeleteTrainer(trainer)}
                        />
                        {/* </Button> */}
                      </li>
                    );
                  })}
                </ul>
              )}

            </div>


            {batchData.assessors?.length > 0 && (
              <div className="mb-3">
                <div className="d-flex align-items-center mb-2">
                  <h5 className="mb-0">Selected Assessors</h5>
                </div>
                <ul className="list-unstyled">
                  {batchData.assessors.map((assessor, index) => {
                    const assessorName1 = assessor.replace(/\(.*\)/, "").trim();
                    return (
                      <li key={index} className="d-flex justify-content-between align-items-center border p-2 mb-2 rounded">
                        <div>{index + 1}. {assessorName1}</div>
                        {/* <Button variant="contained" color="error" onClick={() => handleDeleteAssessor(assessor)}> */}
                        <DeleteRoundedIcon
                          className="text-danger"
                          style={{ color: 'red', marginLeft: 10 }}
                          onClick={() => handleDeleteAssessor(assessor)}
                        />
                        {/* </Button> */}
                      </li>
                    );
                  })}
                </ul>
                <p><strong>Total Selected Facilitators:</strong> {batchData.trainers.length + batchData.assessors.length}</p>
              </div>
            )}
          </div>



          {/* Days and Sessions */}
          <div className="mb-4">
            <div className="d-flex justify-content-between align-items-center mb-3" style={{ position: 'relative' }}>
              <div style={{ width: '100%', textAlign: 'center', fontWeight: 'bold', fontSize: '1.6rem' }}>
                Schedule
              </div>
              <Button
                onClick={handleAddRow}
                variant="contained"
                style={{
                  background: buttonBackgroundColor,
                  fontSize: '12px',
                  position: 'absolute',
                  right: 0,
                }}
              >
                + Add Day
              </Button>
            </div>

            {batchData.days.map((day, dayIndex) => (
              <div key={dayIndex} className="border rounded p-3 mb-3">
                <Row className="mb-3">
                  <Col md={4}>
                    <label htmlFor={`day-${dayIndex}`} className="text-start d-block">Select Day:{dayIndex + 1}</label>
                    <select
                      id={`day-${dayIndex}`}
                      className="form-control"
                      name="day"
                      value={day.day}
                      onChange={(event) => handleInputChange11(dayIndex, "day", event)}
                      required
                    >
                      <option value="" disabled>Select a day</option>
                      {[
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday",
                        "Sunday",
                      ].map((dayName) => {
                        const disabledDays = getDisabledDays(dayIndex);
                        return (
                          <option key={dayName} value={dayName} disabled={disabledDays[dayName]}>
                            {dayName}
                          </option>
                        );
                      })}
                    </select>
                  </Col>

                </Row>

                {Object.keys(day.sessions).map((sessionKey, sessionIndex) => (
                  <Row key={sessionKey} className="mb-2 align-items-end">
                    <Col md={2}>
                      <label className="text-start d-block">Session:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={sessionKey}
                        readOnly
                      />
                    </Col>
                    <Col md={4}>
                      <label className="text-start d-block">Start Time:</label>
                      <input
                        type="time"
                        className="form-control"
                        value={day.sessions[sessionKey].startTime}
                        onChange={(e) => handleSessionChange(dayIndex, sessionIndex, "startTime", e)}
                      />
                    </Col>
                    <Col md={4}>
                      <label className="text-start d-block">End Time:</label>
                      <input
                        type="time"
                        className="form-control"
                        value={day.sessions[sessionKey].endTime}
                        onChange={(e) => handleSessionChange(dayIndex, sessionIndex, "endTime", e)}
                      />
                    </Col>
                    <Col md={2} className="text-center">

                      <Button
                        variant="contained"
                        color="error"
                        style={{ height: "47px", fontSize: "12px", margin: '10px 0px 4px 0px' }}
                        onClick={() => handleRemoveSession(dayIndex, sessionIndex)}
                      >
                        Remove session
                      </Button>


                    </Col>
                  </Row>
                ))}

                {/* <div className="d-flex justify-content-end gap-2 mt-3"> */}
                <Button
                  onClick={() => handleAddSession(dayIndex)}
                  variant="contained"
                  style={{ background: buttonBackgroundColor, marginRight: '20px' }}
                >
                  + Add Session
                </Button>
                {batchData.days.length > 1 && (
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleRemoveRow(dayIndex)}
                  >
                    Remove Day
                  </Button>
                )}

                {/* </div> */}
              </div>
            ))}
            {/* <Button onClick={handleAddRow} variant="contained" style={{ background: buttonBackgroundColor }}>
              + Add Day
            </Button> */}
          </div>
          <FormGroup className="p-3 border rounded bg-light mb-4">
            <FormLabel className="mb-2" style={{ fontWeight: "bold", fontSize: "1.6rem" }}>
              Assignment
            </FormLabel>
            <div className="d-flex align-items-center">
              <FormCheck
                type="checkbox"
                label="Assignment"
                name="assignment"
                id="assignment"
                checked={batchData.assignment}
                onChange={handleInputChange}
                className="me-2"
              />
              <span className={batchData.assignment ? "text-success" : "text-danger"}>
                {batchData.assignment ? "Yes" : "No"}
              </span>
            </div>
          </FormGroup>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Button
              variant="contained"
              type="button"
              style={{
                maxWidth: "15.5%",
                backgroundColor: "red",
                fontSize: "13px",
              }}
            >
              <Link
                to="/Batches"
                style={{ color: "white", textDecoration: "none" }}
              >
                Cancel
              </Link>
            </Button>

            <Button
              type="button"
              variant="contained"
              color="success"
              onClick={handleUpdate}
              style={{
                maxWidth: "15.5%",
                fontSize: "13px",
                marginLeft: "10px", // <-- This adds space between buttons
              }}
            >
              Submit
            </Button>
          </div>

        </div>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Trainer/Assessor Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row align-items-center">
              <div className="col-md-4">
                <div className="input-group mb-3">
                  <span className="input-group-text">Search</span>
                  <input
                    type="text"
                    id="search"
                    className="form-control"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{ height: " 38px " }}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="input-group mb-3">
                  <span className="input-group-text">Show</span>
                  <select
                    id="itemsPerPage"
                    className="form-control"
                    value={itemsPerPage}
                    onChange={(e) =>
                      setItemsPerPage(Number(e.target.value))
                    }
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                  </select>
                </div>
              </div>
            </div>

            {facilitatorData && facilitatorData.length > 0 ? (
              <>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>NRIC</th>
                      <th>Add Trainer</th>
                      <th>Add Assessor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {facilitatorData
                      .filter(
                        (facilitator) =>
                          facilitator.name
                            .toLowerCase()
                            .includes(searchText.toLowerCase()) ||
                          facilitator.email
                            .toLowerCase()
                            .includes(searchText.toLowerCase()) ||
                          facilitator.nric
                            .toLowerCase()
                            .includes(searchText.toLowerCase())
                      )
                      .slice(
                        (currentPage - 1) * itemsPerPage,
                        currentPage * itemsPerPage
                      )
                      .map((facilitator) => {
                        const isTrainerSelected = selectedTrainers.includes(
                          facilitator.name + "(" + facilitator.id + ")"
                        );
                        const isAssessorSelected =
                          selectedAssessors.includes(
                            facilitator.name + "(" + facilitator.id + ")"
                          );

                        // Determine if the Add buttons should be disabled
                        const disableAddTrainer =
                          selectedTrainers.length >= 1 || isTrainerSelected;
                        const disableAddAssessor =
                          selectedAssessors.length >= 1 ||
                          isAssessorSelected;

                        return (
                          <tr key={facilitator.id}>
                            <td>{facilitator.name}</td>
                            <td>{facilitator.email}</td>
                            <td>{facilitator.nric}</td>
                            <td>
                              <Button
                                variant="contained"
                                type="button"
                                onClick={() =>
                                  handleSelectTrainer(
                                    facilitator.name +
                                    "(" +
                                    facilitator.id +
                                    ")"
                                  )
                                }
                                disabled={disableAddTrainer}
                                style={{
                                  backgroundColor: disableAddTrainer
                                    ? "#d3d3d3"
                                    : buttonBackgroundColor,
                                  color: "white",
                                  border: "none",
                                  padding: "10px 20px",
                                  borderRadius: "7px",
                                }}
                              >
                                <FaPlus /> Add
                              </Button>
                            </td>
                            <td>
                              <Button
                                variant="contained"
                                onClick={() =>
                                  handleSelectAssessor(
                                    facilitator.name +
                                    "(" +
                                    facilitator.id +
                                    ")"
                                  )
                                }
                                disabled={disableAddAssessor}
                                style={{
                                  backgroundColor: disableAddAssessor
                                    ? "#d3d3d3"
                                    : buttonBackgroundColor,
                                  color: "white",
                                  border: "none",
                                  padding: "10px 20px",
                                  borderRadius: "7px",
                                }}
                              >
                                <FaPlus /> Add
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </>
            ) : (
              <p></p>
            )}
          </Modal.Body>
        </Modal>
        {/* </div> */}
        {/* </div > */}
      </form >

      <Modal show={showConfirmationModal} onHide={cancelRemoveDay} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to remove this day?</Modal.Body>
        <Modal.Footer>
          <Button variant="contained" style={{ background: 'red' }} onClick={cancelRemoveDay}>
            Cancel
          </Button>
          <Button variant="contained" style={{ background: buttonBackgroundColor }} onClick={confirmRemoveDay}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showUpdateConfirmationModal}
        onHide={handleCancelUpdate}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to update this course?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="contained"
            style={{ background: 'red', marginRight: '10px' }}
            onClick={handleCancelUpdate}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{ background: buttonBackgroundColor }}
            onClick={handleConfirmUpdate}
          >
            Confirm
          </Button>
        </Modal.Footer>

      </Modal>
      <ToastContainer position="bottom-right" />
    </div >
  );
};

const EditBatch = ({ onFormSubmit }) => {
  return (
    <div>
      <Header />
      <EditBatchForm onFormSubmit={onFormSubmit} />
    </div>
  );
};

export default EditBatch;
